<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent">The Battle of Loos saw the first use of poison gas by the British, an operation which had mixed results and in places caused more casualties amongst British troops than German. Certainly the perceived failure of his grip of command of the BEF during the Loos offensive was the straw that finally broke Sir John French’s back, ultimately leading to his recall and his replacement as Commander-in-Chief by Sir Douglas Haig. The aftermath of Loos, and the final breakdown of the French assaults north of Arras and in the Champagne region further south, also saw the front line in this part of France becoming quieter as offensive action shifted to other sectors of the Western Front. This was a situation that inevitably gave rise to a profusion of more permanent concrete structures appearing along the German front line and in rear areas. Many of these blockhouses remain in situ today and are often the only physical remnants of this largely overlooked sector of the Western Front. That said, the landscape – which has one of the highest concentrations of military cemeteries on the Western Front – has changed very little over the course of the last hundred years.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 26_fm039.vue?58fae0e1